import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { SharedService } from "../shared.service";

@Injectable({
  providedIn: "root",
})
export class DiagramComponentService {
  constructor(private http: HttpClient) {}

  getComponenteInfo(diagramaId: string, componenteId: string): Observable<any> {
    const payload = {
      diagramaId: diagramaId,
      jsonComponenteId: componenteId,
      page: 1,
      limit: 100,
    };

    return this.http.post<any>(`${environment.api_server}/api/diagrama/componentes/infos`, payload, { headers: SharedService.header }).pipe(
      map((response) => {
        if (response && response.code === 200) {
          return response;
        } else {
          throw new Error("Erro ao buscar informações do componente");
        }
      }),
      catchError((error) => {
        console.error("Erro na requisição:", error);
        throw error;
      })
    );
  }

  uploadPdf(data: FormData): Observable<any> {
    return this.http.post(`${environment.api_server}/api/newtecnoscopio/pdf/diagrama/upload`, data, { headers: SharedService.header }).pipe(
      catchError((error) => {
        console.error("Erro ao fazer upload do PDF:", error);
        throw error;
      })
    );
  }

  removePdf(pdfId: string, diagramaId: string, jsonComponenteId: string): Observable<any> {
    return this.http
      .post(
        `${environment.api_server}/api/newtecnoscopio/pfd/remove`,
        {
          pdfId: pdfId,
          jsonComponenteId: jsonComponenteId,
          diagramaId: diagramaId,
        },
        { headers: SharedService.header }
      )
      .pipe(
        catchError((error) => {
          console.error("Erro ao remover PDF:", error);
          throw error;
        })
      );
  }

  uploadFoto(data: FormData): Observable<any> {
    return this.http.post(`${environment.api_server}/api/newtecnoscopio/foto/diagrama/upload`, data, { headers: SharedService.header }).pipe(
      catchError((error) => {
        console.error("Erro ao fazer upload da foto:", error);
        throw error;
      })
    );
  }

  removeFoto(fotoId: string, diagramaId: string, jsonComponenteId: string): Observable<any> {
    return this.http
      .post(
        `${environment.api_server}/api/newtecnoscopio/foto/remove/componente`,
        {
          fotoId: fotoId,
          jsonComponenteId: jsonComponenteId,
          diagramaId: diagramaId,
        },
        { headers: SharedService.header }
      )
      .pipe(
        catchError((error) => {
          console.error("Erro ao remover foto:", error);
          throw error;
        })
      );
  }
}
